import { apiClient } from '@/shared/api';
import {
  handleRequest,
  type RequestHandlerOptions,
} from '@/shared/api/apiWrapper';
import type { GenerateIncomeStatementResponseDto } from '../model';
import type { Language } from '@/shared/types';

const generateIncomeStatement = async (
  lang: Language,
  options?: RequestHandlerOptions
) => {
  const request = () =>
    apiClient.get('/users/profile/accountLetter', {
      params: {
        lang,
      },
    });
  const response = await handleRequest<GenerateIncomeStatementResponseDto>(
    request,
    options
  );
  return response.data;
};

export { generateIncomeStatement };
